export default __webpack_public_path__ + "static/wind-turbine-cfbabe51dd4358cc726cef509e41aa6d.png";